import {
  useAtsCommTemplateVariables,
  type AtsCommTemplateVariables,
} from '@/api/atsCommTemplates';

/**
 * View scopes per communication block.
 * These map to `?view[]=...` params on `GET /api_ats/v1/ats_comm_templates/variables`.
 */
const CANDIDATE_CALENDAR_VIEWS = [
  'sender',
  'interview',
  'job',
  'candidate',
  'org',
] as const;
const INTERVIEWER_CALENDAR_VIEWS = [
  'sender',
  'interview',
  'job',
  'candidate',
  'org',
] as const;
const CANDIDATE_EMAIL_VIEWS = ['sender', 'candidate', 'org', 'job'] as const;
const INTERVIEWER_EMAIL_VIEWS = [
  'sender',
  'interview',
  'job',
  'candidate',
  'org',
] as const;
const SELF_SCHEDULE_EMAIL_VIEWS = [
  'sender',
  'interview',
  'job',
  'candidate',
  'org',
] as const;

/**
 * Merge-variable buckets for each Communication block.
 * Each block fetches its own set of variables based on the view scopes above.
 */
export function useInterviewActivityCommunicationVariables(): {
  candidateCalendar: AtsCommTemplateVariables;
  interviewerCalendar: AtsCommTemplateVariables;
  candidateEmail: AtsCommTemplateVariables;
  interviewerEmail: AtsCommTemplateVariables;
  selfScheduleEmail: AtsCommTemplateVariables;
} {
  const { data: candidateCalendar = {} } = useAtsCommTemplateVariables(
    CANDIDATE_CALENDAR_VIEWS
  );
  const { data: interviewerCalendar = {} } = useAtsCommTemplateVariables(
    INTERVIEWER_CALENDAR_VIEWS
  );
  const { data: candidateEmail = {} } = useAtsCommTemplateVariables(
    CANDIDATE_EMAIL_VIEWS
  );
  const { data: interviewerEmail = {} } = useAtsCommTemplateVariables(
    INTERVIEWER_EMAIL_VIEWS
  );
  const { data: selfScheduleEmail = {} } = useAtsCommTemplateVariables(
    SELF_SCHEDULE_EMAIL_VIEWS
  );

  return {
    candidateCalendar,
    interviewerCalendar,
    candidateEmail,
    interviewerEmail,
    selfScheduleEmail,
  };
}
